import { call, fork, put, takeEvery } from 'redux-saga/effects';
import {
  FETCH_WORKFLOW_STATUS_LIST,
  UPDATE_WORKFLOW_STATUS_LIST,
  updateWorkFlowStatusListSuccess,
  updateWorkFlowStatusListFail,
  fetchWorkFlowStatusListSuccess,
  fetchWorkFlowStatusListFail
} from '../../redux/actions/cm/workFlowStatus';
import {
  fetchWorkFlowStatusList,
  updateWorkFlowStatusList
} from '../../services/cm/workFlowStatus';

export function* fetchWorkFlowStatusListWorker() {
  try {
    const workFlowStatuses = yield call(fetchWorkFlowStatusList) || [];
    const modifiedWorkFlowStatuses = workFlowStatuses.workflowStatus.map(
      (status) => ({
        ...status,
        dynamicValue: status.currentValue
      })
    );
    yield put(fetchWorkFlowStatusListSuccess(modifiedWorkFlowStatuses));
  } catch (error) {
    yield put(fetchWorkFlowStatusListFail(error));
  }
}

function* updateWorkFlowStatusListWorker({ statusList }) {
  try {
    const res = yield call(updateWorkFlowStatusList, {
      statusList
    });

    yield put(updateWorkFlowStatusListSuccess(res.workflowStatus));
  } catch (error) {
    yield put(updateWorkFlowStatusListFail(error));
  }
}

export function* watchFetchWorkFlowStatusList() {
  yield takeEvery(FETCH_WORKFLOW_STATUS_LIST, function* () {
    yield fork(fetchWorkFlowStatusListWorker);
  });
}

export function* watchUpdateWorkFlowStatusList() {
  yield takeEvery(
    UPDATE_WORKFLOW_STATUS_LIST,
    function* ({ payload: statusList }) {
      yield fork(updateWorkFlowStatusListWorker, { statusList });
    }
  );
}
